<div class="bulb-resume-custom-section">
  <div class="drag-line" pDroppable="section" (onDrop)="drop($event, customSection)"></div>
  <span [ngClass]="{'show-handle': !editMode && canEdit}" pDraggable="section" (onDragStart)="dragStart($event, customSection)" class="resume-drag-handle">
    <svg-icon
      [key]="'grip-lines-solid'"
      fontSize="1.5rem">
  </svg-icon>
  </span>
  <bulb-resume-section
    sectionName="{{customSubSectionClone.customTitle}}"
    [resumeSection]="customSection"
    [resumeComponent]="resumeComponent"
    [showEditIcon]="!editMode && canEdit"
    [showDeleteIcon]="canEdit && !editMode"
    [canEdit]="canEdit"
    [(open)]="isTabOpen"
    (onEdit)="beginEdit()"
    (onClose)="handleTabClose()"
    (onOpen)="handleTabOpen()"
    pDraggable="section"
    pDroppable="section"
    (onDrop)="drop($event, customSection)"
    (onDragStart)="dragStart($event, customSection)"
    [pDraggableDisabled]="isTabOpen">

    <div sectionContent>
      <bulb-resume-sub-section [allowSubSectionDelete]="true"
                   [editMode]="editMode"
                   [resumeComponent]="resumeComponent"
                   [resumeSection]="customSection"
                   [isOnlyPortfolioContent]="isOnlyPortfolioContent"
                   [units]="portfolioContent">

        <aero-form subSectionEdit
               submitButtonLabel="{{ 'saveButton' | transloco }}"
               [showCancelButton]="true"
               (onCancel)="cancelEdit()"
               (onSubmit)="save($event)"
               [updateSaveButtonStateOnChange]="false">
          <div class="bulb-custom-textarea-container">
            <aero-input type="text"
                  [id]="'sectionTitle'"
                  label="{{ 'resume.custom.sectionTitle' | transloco }}"
                  name="customTitle"
                  [(ngModel)]="customSubSectionClone.customTitle"
                  [maxlength]="60"
                  [required]="true"
                  (aeroInputNgModelEmitter)="handleInputModelChanges($event)"
                  [autofocus]="true">
            </aero-input>
            <label transloco="resume.custom.description">Add Information</label>
            <bulb-editor *ngIf="editMode"
                         name="customDescription"
                         id="customDescription"
                         [editable]="true"
                         [initData]="customSubSectionClone.customDescription"
                         (dataChange)="updateCustomData($event)"
                         (limitReached)="handleLimitReached($event)"
                         [maxLength]="maxLength">
            </bulb-editor>
          </div>

          <div class="text-center bulb-resume-add-btn ">
            <aero-button [aeroStyle]="buttonStyle"
                   icon="fal fa-plus"
                   label="{{ 'resume.add.portfolioContent' | transloco }}"
                   (onClick)="addPortfolioContent()">
            </aero-button>
          </div>

          <!-- Show the selected portfolio content : -->
          <bulb-resume-content-selection-display
            [aeroFormComponent]="aeroFormComponent"
            [resumeSubSection]="this"
            [editMode]="editMode"
            [units]="portfolioContent"
            [renderResumeSubSectionTileView]="true"
            (onUnitRemoved)="onPortfolioContentRemoved()">
          </bulb-resume-content-selection-display>
        </aero-form>
        <div subSectionView>
          <p [innerHTML]="customSubSectionClone.customDescription" class="custom-add-information"></p>
        </div>
      </bulb-resume-sub-section>
    </div>
  </bulb-resume-section>

</div>
